import React, { useContext } from 'react';
import { AlertContext } from '../AlertContext';

function Alert() {
  const { alert } = useContext(AlertContext);

  const alertContainerStyle = {
   
    marginTop: '80px', // Adjust this value based on the header height and desired spacing
    height: '60px',
    zIndex:'998',
    
  };


  return (
    <div style={alertContainerStyle}>
      {alert && (
        <div className={`alert alert-${alert.type} alert-dismissible fade show text-center`}  role="alert">
          <strong>{alert.msg}</strong>
        </div>
      )}
    </div>
  );
}

export default Alert;
